"use client";
import React from "react";
import { IoLogoGooglePlaystore } from "react-icons/io5";
import { FaAppStoreIos } from "react-icons/fa";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/navigation";

const PostSubmit = () => {
  const router = useRouter();
  return (
    <div className="flex gap-8 flex-col justify-center text-center">
      <p>
        Rest assured, you’ll be receiving a comprehensive report via email as
        soon as it is ready
      </p>
      <div className="flex gap-8 justify-center">
        {postSubmitCta?.map((el) => {
          return (
            <div
              key={el.text}
              className="flex flex-col gap-4 justify-between items-center w-36"
            >
              <Link href={el.link}>
                <Image
                  src={el.icon}
                  alt={el.text}
                  height={60}
                  width={60}
                  className="cursor-pointer"
                />
              </Link>
              <p className="text-center">{el.text}</p>
            </div>
          );
        })}
      </div>
      <button
        onClick={() => router.push("/all-products")}
        className="w-full bg-black text-white font-semibold rounded-lg py-4 mt-8"
      >
        Finish
      </button>
    </div>
  );
};

export default PostSubmit;

const bonatraAppInfo = [
  "Get Accurate Biological age using your Blood Report.",
  "Get useful insights to reverse your aging",
  "Join the Bonatra’s Age Reversal programs to get exciting Results.",
];

const postSubmitCta = [
  {
    text: "Join Whatsapp Community",
    icon: "https://storage.googleapis.com/bonatra-assets/BonatraApplicationAssets/Join%20Community.svg",
    link: "https://chat.whatsapp.com/GJfiIAN2l5iFyF9Z6ZWn0o",
  },
  {
    text: "Explore Age-reversal Program",
    icon: "https://storage.googleapis.com/bonatra-assets/BonatraApplicationAssets/Age%20Reversal%20Programs.svg",
    link: "/package/age-reversal",
  },
  {
    text: "Visit our E-commerce store",
    icon: "https://storage.googleapis.com/bonatra-assets/BonatraApplicationAssets/StoreBio.svg",
    link: "/all-products",
  },
];
let appInsights = [
  {
    id: 1,
    ratings: 4.3,
    platformIcon: (
      <IoLogoGooglePlaystore
        size={15}
        className="text-black-400 max-w-[25px]"
      />
    ),
    platformTitle: "Play Store",
    platformImage: "https://assets.bonatra.com/package_detail/App%20Store.webp",
    link: "https://apps.apple.com/in/app/bonatra/id1600079061",
    alt: "Google play logo",
  },
  {
    id: 2,
    ratings: 4.4,
    platformIcon: (
      <FaAppStoreIos size={15} className="text-black-400 max-w-[25px]" />
    ),
    platformTitle: "App Store",
    platformImage:
      "https://assets.bonatra.com/package_detail/e2a73d3a-a5fb-459c-ad75-ee3f9c4a1d3e.webp",
    link: "https://play.google.com/store/apps/details?id=com.yoihealth",
    alt: "app store",
  },
];
